import {
  faFlag as faFlagSolid,
  faSearch,
  faTimes,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import TaskService from "../util/TaskService";
import UserService from "../util/UserService";
import "./custom_multiselect.css";
import { values } from "lodash";
import { color } from "highcharts";
import {invertColor} from "../../common/util/appUtils"
const CustomMultiSelect = ({
  options,
  icon,
  onChange,
  values,
  id,
  opendDropdowns,
  setOpendDropDowns,
  removeTile,
  filterIndex,
  GroupIndex,
}) => {
  const [expanded, setExpand] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const newRef = useRef();
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setExpand(false);           
        setOpendDropDowns("");      
      }
    }
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [setOpendDropDowns]);
  useEffect(() => {
    setExpand(id === opendDropdowns);
  }, [opendDropdowns, id]);

  const openDeopDown = (e) => {
    e.stopPropagation(); // Prevent outside click from closing immediately
    setOpendDropDowns(expanded ? "" : id);
  };
  //new code end

  const getFilterValues = () => {
    if (!searchText) return options;
    return options.filter((one) =>
      one.name.toLowerCase().includes(searchText.toLowerCase())
    );
  };
  const isChecked = (one) => values?.some((val) => val.name === one.name);


  const getOptionByIcon = () => {
    let filtered = getFilterValues();
    if (icon === "Account Name") {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    }
  
    // Rest of your filtering and sorting logic for other icons
    if (icon === "Number of Interconnection") {
      filtered.sort((a, b) => parseInt(a.id) - parseInt(b.id));
    }
  
    options = filtered;
  
    // Rendering for different icon types (no changes here)
    if (icon === "Assignee" || icon === "Created By" || icon === "Supervisor") {
      return (
        options &&
        options.map((one, index) => {
          return (
            <label for={"option" + index} key={index}>
              <input
                checked={isChecked(one)}
                onChange={(e) => onChange(e.currentTarget.checked, one, index)}
                type="checkbox"
                id="three"
              />
              <span className="cust-drop-icon">
                <img src={UserService.GetUserPhotoUrl(one.id)} />
              </span>
              <span className="cust-drop-text">{one.name}</span>
            </label>
          );
        })
      );
    } else if (
      icon === "Account Name" ||
      icon === "Status" ||
      icon === "Project Status"
    ) {
      return (
        options &&
        options.map((one, index) => {
          return (
            <label for={"option" + index} key={index}>
              <input
                checked={isChecked(one)}
                onChange={(e) => onChange(e.currentTarget.checked, one, index)}
                type="checkbox"
                id="three"
              />
              <span className="cust-drop-icon">
                <span style={{ backgroundColor: one.color }}></span>
              </span>
              <span style={{ left: 22 }} className="cust-drop-text">
                {one.name}
              </span>
            </label>
          );
        })
      );
    } else if (icon === "Priority") {
      return (
        options &&
        options.map((one, index) => {
          return (
            <label for={"option" + index} key={index}>
              <input
                checked={isChecked(one)}
                onChange={(e) => onChange(e.currentTarget.checked, one, index)}
                type="checkbox"
                id="three"
              />
              <span className="cust-drop-icon">
                <FontAwesomeIcon color={one.color} icon={faFlagSolid} />
              </span>
              <span className="cust-drop-text">{one.name}</span>
            </label>
          );
        })
      );
    } else {
      return (
        options &&
        options.map((one, index) => {
          return (
            <label for={"option" + index} key={index}>
              <input
                checked={isChecked(one)}
                onChange={(e) => onChange(e.currentTarget.checked, one, index)}
                type="checkbox"
                id="three"
              />
              <span className="cust-drop-icon"></span>
              <span className="cust-drop-text">
                {one.name.includes("_") ? one.name.split("_")[0] : one.name}
              </span>
            </label>
          );
        })
      );
    }
  };
  
  
  // const getOptionByIcon = () => {
  //   options = getFilterValues();
  //   const ids = options.map(({ id }) => id);
  //   const filtered = options.filter(
  //     ({ id }, index) => !ids.includes(id, index + 1)
  //   );
  //   if (icon == "Number of Interconnection") {
  //     filtered.sort(function (a, b) {
  //       return parseInt(a.id) - parseInt(b.id);
  //     });
  //   }
  //   options = filtered;

  //   if (icon == "Assignee" || icon == "Created By" || icon == "Supervisor") {
  //     return (
  //       options &&
  //       options.map((one, index) => {
  //         return (
  //           <label for={"option" + index}>
  //             <input
  //               checked={isChecked(one)}
  //               onChange={(e) => onChange(e.currentTarget.checked, one, index)}
  //               type="checkbox"
  //               id="three"
  //             />
  //             <span className="cust-drop-icon">
  //               <img src={UserService.GetUserPhotoUrl(one.id)} />
  //             </span>
  //             <span className="cust-drop-text">{one.name}</span>
  //           </label>
  //         );
  //       })
  //     );
  //   } else if (
  //     icon == "Account Name" ||
  //     icon == "Status" ||
  //     icon == "Project Status"
  //   ) {
  //     return (
  //       options &&
  //       options.map((one, index) => {
  //         return (
  //           <label for={"option" + index}>
  //             <input
  //               checked={isChecked(one)}
  //               onChange={(e) => onChange(e.currentTarget.checked, one, index)}
  //               type="checkbox"
  //               id="three"
  //             />
  //             <span className="cust-drop-icon">
  //               <span style={{ backgroundColor: one.color }}></span>
  //             </span>
  //             <span style={{ left: 22 }} className="cust-drop-text">
  //               {one.name}
  //             </span>
  //           </label>
  //         );
  //       })
  //     );
  //   } else if (icon == "Priority") {
  //     return (
  //       options &&
  //       options.map((one, index) => {
  //         return (
  //           <label for={"option" + index}>
  //             <input
  //               checked={isChecked(one)}
  //               onChange={(e) => onChange(e.currentTarget.checked, one, index)}
  //               type="checkbox"
  //               id="three"
  //             />
  //             <span className="cust-drop-icon">
  //               <FontAwesomeIcon color={one.color} icon={faFlagSolid} />
  //             </span>
  //             <span className="cust-drop-text">{one.name}</span>
  //           </label>
  //         );
  //       })
  //     );
  //   } else {
  //     return (
  //       options &&
  //       options.map((one, index) => {
  //         return (
  //           <label for={"option" + index}>
  //             <input
  //               checked={isChecked(one)}
  //               onChange={(e) => onChange(e.currentTarget.checked, one, index)}
  //               type="checkbox"
  //               id="three"
  //             />
  //             <span className="cust-drop-icon"></span>
  //             <span className="cust-drop-text">{one.name.includes("_")?one.name.split("_")[0]:one.name}</span>
  //           </label>
  //         );
  //       })
  //     );
  //   }
  // };

  function ApplyColor(bgcolor, one) {
    return { background: bgcolor, color: invertColor(bgcolor, true), display : one.name != "Select All" ? "" : "none" };
  }
  return (
    <div id="custom_dropdown" className="multiselect" ref={dropdownRef}>
      <div className="custom-tiles text-truncate overSelect" onClick={openDeopDown}>
        {(!values || values.length === 0) && "Select Option"}
        {values?.map((one, i) => (
          <span
                key={i}
            className="tile-span"
            style={
              one.color
                ? ApplyColor(one.color, one)
                : { background: "rgb(91, 108, 151)", display: one.name !== "Select All" ? "" : "none" }
                }
                id={one.id}
          >
            {one.name.includes("_") ? one.name.split("_")[0] : one.name}
            <FontAwesomeIcon
              onClick={(e) => {
                e.stopPropagation();
                    removeTile(one.id, filterIndex, GroupIndex, e)
              }}
                  className="remove-tile"
                  icon={faTimesCircle}
                />
              </span>
        ))}
      </div>
      <div className="selectBox" onClick={openDeopDown}>
        <select>
          <option>
            <span style={{ padding: "5px", backgroundColor: "yellow" }}>
              ksafgjadsgfdsgjas
            </span>
          </option>
        </select>
        <div className="overSelect"></div>
      </div>
      {expanded && (
        <div className="custom-dropdown-box checkboxes" id={id} onClick={(e) => e.stopPropagation()}>
        <div className="form-group form-group-sm filter-search-box">
          <input
            type="text"
            placeholder="Search"
            className="mr-sm-2 pad-fix search-filter"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
              onClick={(e) => e.stopPropagation()}
          />

          <FontAwesomeIcon className="mr-sm-2 search-ico" icon={faSearch} />
        </div>
        <div className="filter-drop-list">{getOptionByIcon()}</div>
        </div>
      )}
    </div>
  );
};

export default CustomMultiSelect;
